/* eslint-disable */
import React, { useContext, useEffect } from "react";
import { Modal, Image } from "react-bootstrap";
import CorrectIcon from "../../assets/img/CorrectIcon.png";
import { useSelector, useDispatch } from "react-redux";
import wsSend_request from "../../Api/ws/ws_request";
import { WebSocketContext } from "../../App";
import CommonDateTime from "./CommonDateTime";
import {
  StartMainCommonLoader,
  getOrderLogList,
} from "../../redux/actions/adminActions";
import moment from "moment";
import CommonScrollBar from "./CommonScrollBar";
import QuotationsStatus from "./QuotationsStatus";

const OrderStatusModel = (props) => {
  const { OrderNewModel, setOrderNewModel } = props;
  const { device_id, AllOrderLogList, commonMainLoader, user_id } = useSelector(
    (state) => state.adminReducers
  );
  const { websocket } = useContext(WebSocketContext);
  const Dispatch = useDispatch();

  const handleClose = () => {
    Dispatch(getOrderLogList({}));
    setOrderNewModel({ ...setOrderNewModel, open: false });
  };

  const getOrderStatus = (status) => {
    if (status === "DELIVERED") {
      return {
        orderStatus: "Inward completed",
      };
    }
    if (
      status === "SO_APPROVED" ||
      status === "SO_HALF_APPROVAL" ||
      status === "SO_FULL_APPROVAL"
    ) {
      return {
        orderStatus: "SO Approved",
      };
    }
    if (status === "AC_APPROVED") {
      return {
        orderStatus: "Accounts Approved",
      };
    }
    if (status === "WH_APPROVED") {
      return {
        orderStatus: "Warehouse Approved",
      };
    }
    if (status === "ST_APPROVED") {
      return {
        orderStatus: "Store Approved",
      };
    }
    if (status === "OPEN") {
      return {
        orderStatus: "Order Created",
      };
    }
    if (status === "REPLACE") {
      return {
        orderStatus: "Order Replace",
      };
    }
    if (status === "CANCELLED") {
      return {
        orderStatus: "Cancelled",
      };
    }
    if (status === "RETURN") {
      return {
        orderStatus: "Order Returned",
      };
    }
    if (status === "REPLACE_REQUEST") {
      return {
        orderStatus: "Order Replace Request",
      };
    }
    if (status === "SO_APPROVED") {
      return {
        orderStatus: "SO Partially Approved",
      };
    }
    if (status === "WH_PENDING") {
      return {
        orderStatus: "Warehouse Pending",
      };
    }
    if (status === "DISPATCHED") {
      return {
        orderStatus: "Order Dispatched",
      };
    }
    if (status === "REJECTED") {
      return {
        orderStatus: "Rejected",
      };
    }
    if (status === "RETURN_IN_TRANSIT") {
      return {
        orderStatus: "Return In Transit",
      };
    }
    if (status === "CANCELLED_REQUEST") {
      return {
        orderStatus: "Cancelled Request",
      };
    }
    if (status === "RETURN_REQUEST") {
      return {
        orderStatus: "Return Request",
      };
    }
    if (status === "PARTIALLY_RETURN") {
      return {
        orderStatus: "Partially Return",
      };
    }
    if (status === "INVOICE_PENDING") {
      return {
        orderStatus: "Pending Invoicing",
      };
    }
    if (status === "DISPATCH_PENDING") {
      return {
        orderStatus: "Pending Dispatch",
      };
    }
    if (status === "UC_UPCOMING") {
      return {
        orderStatus: "Upcoming Orders",
      };
    }
    if (status === "PAYMENT_PENDING") {
      return {
        orderStatus: "Website Order Payment Approval",
      };
    }
    if (status === "DRAFT") {
      return {
        orderStatus: "Draft Order",
      };
    }
    if (status === "RENEW") {
      return {
        orderStatus: "Renewed",
      };
    }
  };

  // get user
  const GetUserData = (id) => {
    const usersIdwise = AllOrderLogList?.users.reduce((acc, curr) => {
      acc[curr.id] = curr;
      return acc;
    }, {});

    if (usersIdwise[id]?.id === undefined) {
      return {
        userName: "-",
      };
    } else {
      return {
        userName:
          usersIdwise[id]?.id === user_id ? "You" : usersIdwise[id].full_name,
      };
    }
  };

  //get updateat date only
  const UpdatedAt = (updated_at) => {
    const timestamp = new Date(updated_at);
    const dateOnly = timestamp.toISOString().split("T")[0];
    return {
      updated_at: dateOnly,
    };
  };

  // get order_log list all
  useEffect(() => {
    if (OrderNewModel?.Data?.length > 0) {
      Dispatch(
        StartMainCommonLoader({
          url:
            OrderNewModel?.title === "AFS Order Log"
              ? "afs_order_logs"
              : OrderNewModel?.title === "AFS Quotation Log"
              ? "quotation_logs"
              : "order_logs",
          loader: true,
        })
      );
      let param = {
        transmit: "broadcast",
        url:
          OrderNewModel?.title === "AFS Order Log"
            ? "afs_order_logs"
            : OrderNewModel?.title === "AFS Quotation Log"
            ? "quotation_logs"
            : "order_logs",
        request: {},
        DeviceId: device_id,
      };
      if (
        OrderNewModel?.title === "AFS Order Log" ||
        OrderNewModel?.title === "Order Log"
      ) {
        param.request.order_id = OrderNewModel?.Data;
      } else {
        param.request.quotation_id = OrderNewModel?.Data;
      }

      wsSend_request(websocket, param);
    }
  }, [OrderNewModel, device_id]);

  const LoadingLogs =
    (commonMainLoader?.url === "afs_order_logs" ||
      commonMainLoader?.url === "order_logs" ||
      commonMainLoader?.url === "quotation_logs") &&
    commonMainLoader?.loader;

  return (
    <Modal
      className="order_logs_wrapper"
      show={OrderNewModel?.open}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title
          style={{
            width: OrderNewModel?.title === "Are you sure?" ? "100%" : "",
          }}
        >
          {OrderNewModel?.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CommonScrollBar height={{ height: 300 }}>
          <div
            className="container-fluid ps-0"
            style={{ whiteSpace: "nowrap" }}
          >
            {OrderNewModel?.title === "AFS Order Log" ||
            OrderNewModel?.title === "Order Log" ? (
              <React.Fragment>
                {Object?.keys(AllOrderLogList)?.length > 0 &&
                  AllOrderLogList?.order_logs
                    ?.slice()
                    .reverse()
                    .map((log, index, array) => (
                      <div
                        className="row justify-content-around"
                        style={{ margin: "0px" }}
                        key={log.id}
                      >
                        <div className="order_logs_box">
                          <div
                            className="col-1 completed-icon"
                            style={{ position: "absolute", left: "0px" }}
                          >
                            {log.order_status && (
                              <span className="completed">
                                <Image
                                  src={CorrectIcon}
                                  height={16}
                                  width={16}
                                />
                              </span>
                            )}
                          </div>
                          <div className="col-7">
                            <span
                              style={{
                                display: "block",
                                fontSize: "13px",
                                fontWeight: "600",
                              }}
                            >
                              {getOrderStatus(log?.order_status)?.orderStatus}
                            </span>
                            <small
                              style={{ display: "block", fontSize: "12px" }}
                            >
                              {CommonDateTime(log?.created_at, "LL", "show")}
                            </small>
                            <div
                              className=""
                              style={{
                                display: "block",
                                fontSize: "12px",
                                wordBreak: "break-all",
                                whiteSpace: "break-spaces",
                                paddingRight: "10px",
                              }}
                            >
                              ( {GetUserData(log.author)?.userName} )
                            </div>
                          </div>
                          <div className="col-5">
                            <div style={{ marginBottom: "1px" }}>
                              <span
                                style={{
                                  float: "left",
                                  width: "auto",
                                  fontSize: "12px",
                                  fontWeight: "600",
                                  marginRight: "4px",
                                }}
                              >
                                Updated At :
                              </span>
                              <span
                                className=""
                                style={{ display: "block", fontSize: "12px" }}
                              >
                                {UpdatedAt(log?.updated_at)?.updated_at}
                              </span>
                            </div>
                            <div>
                              <span
                                style={{
                                  float: "left",
                                  width: "auto",
                                  fontSize: "12px",
                                  fontWeight: "600",
                                  marginRight: "4px",
                                }}
                              >
                                Time :
                              </span>
                              <small
                                style={{ display: "block", fontSize: "12px" }}
                              >
                                {moment(log?.updated_at).format("h:mm a")}
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                {LoadingLogs && "Please Wait...."}
                {AllOrderLogList?.order_logs?.length === 0 &&
                  "Order log not found"}
              </React.Fragment>
            ) : (
              <React.Fragment>
                {Object?.keys(AllOrderLogList)?.length > 0 &&
                  AllOrderLogList?.quotation_logs
                    ?.slice()
                    .reverse()
                    .map((log, index, array) => (
                      <div
                        className="row justify-content-around"
                        style={{ margin: "0px" }}
                        key={log.id}
                      >
                        <div className="order_logs_box">
                          <div
                            className="col-1 completed-icon"
                            style={{ position: "absolute", left: "0px" }}
                          >
                            {log.quotation_status && (
                              <span className="completed">
                                <Image
                                  src={CorrectIcon}
                                  height={16}
                                  width={16}
                                />
                              </span>
                            )}
                          </div>
                          <div className="col-7">
                            <span
                              style={{
                                display: "block",
                                fontSize: "13px",
                                fontWeight: "600",
                              }}
                            >
                              {QuotationsStatus(log?.quotation_status)}
                            </span>
                            <small
                              style={{ display: "block", fontSize: "12px" }}
                            >
                              {CommonDateTime(log?.created_at, "LL", "show")}
                            </small>
                            <div
                              className=""
                              style={{
                                display: "block",
                                fontSize: "12px",
                                wordBreak: "break-all",
                                whiteSpace: "break-spaces",
                                paddingRight: "10px",
                              }}
                            >
                              ( {GetUserData(log.author)?.userName} )
                            </div>
                          </div>
                          <div className="col-5">
                            <div style={{ marginBottom: "1px" }}>
                              <span
                                style={{
                                  float: "left",
                                  width: "auto",
                                  fontSize: "12px",
                                  fontWeight: "600",
                                  marginRight: "4px",
                                }}
                              >
                                Updated At :
                              </span>
                              <span
                                className=""
                                style={{ display: "block", fontSize: "12px" }}
                              >
                                {UpdatedAt(log?.updated_at)?.updated_at}
                              </span>
                            </div>
                            <div>
                              <span
                                style={{
                                  float: "left",
                                  width: "auto",
                                  fontSize: "12px",
                                  fontWeight: "600",
                                  marginRight: "4px",
                                }}
                              >
                                Time :
                              </span>
                              <small
                                style={{ display: "block", fontSize: "12px" }}
                              >
                                {moment(log?.updated_at).format("h:mm a")}
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                {LoadingLogs && "Please Wait...."}
                {AllOrderLogList?.order_logs?.length === 0 &&
                  "Order log not found"}
              </React.Fragment>
            )}
          </div>
        </CommonScrollBar>
      </Modal.Body>
    </Modal>
  );
};

export default OrderStatusModel;
